import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
